import React, { useState, useEffect } from 'react';
import Lg from '../assets/img/abstract/saloon.png';
import { useLoginSettings } from '../contexts/loginSettingsContext';
import useDarkMode from '../hooks/useDarkMode';

const Logo = () => {
	const { loginSettings } = useLoginSettings() || {};
	const { darkModeStatus } = useDarkMode();
	const [src, setSrc] = useState(Lg);

	useEffect(() => {
		try {
			const remote = darkModeStatus
				? loginSettings?.site_logo_dark
				: loginSettings?.site_logo;
			if (remote && typeof remote === 'string' && remote.trim()) {
				setSrc(remote);
			} else {
				setSrc(Lg);
			}
		} catch (e) {
			setSrc(Lg);
		}
	}, [loginSettings, darkModeStatus]);

	return (
		<img
			style={{ width: '160px', height: '40px', marginLeft: '10px', objectFit: 'contain' }}
			src={src}
			onError={() => {
				if (src !== Lg) setSrc(Lg);
			}}
			alt='Site Logo'
		/>
	);
};
Logo.propTypes = {};
Logo.defaultProps = {};

export default Logo;
